module.exports = __webpack_public_path__ + "img/marker.72ff6690.svg";